export default __webpack_public_path__ + "static/media/04_photo.95c44e00.jpg";